'use client';
import { Inter } from "next/font/google";
import { Metadata } from "next";
import { AuthProvider } from "../context/AuthContext";
import { QueryProvider } from "@/providers/QueryProvider";
import { ThemeProvider } from "@/providers/ThemeProvider";
import { SocketProvider } from "@/providers/SocketProvider";
import AuthWrapper from "@/components/auth-wrapper";
import "./globals.css";
import ClientProviders from "@/providers/ClientProvider";

const inter = Inter({ subsets: ["latin"] });

export default function RootLayout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en" suppressHydrationWarning>
      <body className={inter.className} suppressHydrationWarning>
        <ThemeProvider defaultTheme="light" storageKey="app-theme">
          <QueryProvider>
            <ClientProviders>
              <SocketProvider>
                <AuthWrapper>{children}</AuthWrapper>
              </SocketProvider>
            </ClientProviders>
          </QueryProvider>
        </ThemeProvider>
      </body>
    </html>
  );
}
